const regex = Object.freeze({
    REGEX_ZAHL_MIT_KOMMA_NULL_ERLAUBT: "^(0)$|(^(0{1,1}(?:,[0-9]{0,2}){0,1})$|^([1-9][0-9]*(?:,[0-9]{0,2}){0,1})$)",
    REGEX_ZAHL_MIT_KOMMA_NULL_ERLAUBT_EINE_ZAHL: "^(0)$|(^(0{1,1}(?:,[0-9]{0,1}){0,1})$|^([1-9][0-9]*(?:,[0-9]{0,1}){0,1})$)",
    KEINE_ZAHL_NACH_KOMMA: "^[0-9]*,$",
    EINFACHE_NULL: "^0$",
});

export default regex;
